import { ASYNC, actionTypes } from "../utils"
import { AsyncRequestStatus } from "../utils/reduxTypes"

type NewsletterActionTypes = {
  newsletter: {
    GET: AsyncRequestStatus
    SUBSCRIBE: AsyncRequestStatus
    UNSUBSCRIBE: AsyncRequestStatus
  }
}

const types = actionTypes({
  newsletter: {
    GET: ASYNC,
    SUBSCRIBE: ASYNC,
    UNSUBSCRIBE: ASYNC,
  },
}) as NewsletterActionTypes

export default types.newsletter
